<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <div v-if="currentFoam == 'Yes'">
                        <p
                            style="margin-top: 1svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; color: #3F616C; font-style: normal; text-align: center; font-size: 16px;">
                            Hay espuma y ha ingerido {{ currentMedicine }} </p>
                        <p
                            style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; color: #3F616C; font-style: normal; text-align: center; font-size: 16px;">
                            Por favor, siga estas instrucciones </p>
                    </div>
                    <div v-else>
                        <p
                            style="margin-top: 1svh; margin-left: 2svw; margin-right: 2svw; font-family: Lato; color: #3F616C; font-style: normal; text-align: center; font-size: 16px;">
                            No hay espuma y ha ingerido {{ currentMedicine }} </p>
                        <p
                            style="margin-left: 2svw; margin-right: 2svw; font-family: Lato; color: #3F616C; font-style: normal; text-align: center; font-size: 16px;">
                            Por favor, siga estas instrucciones </p>
                    </div>
                    <div v-if="this.currentMedicine == 'Citrafleet'">
                        <div v-if="this.currentFoam == 'Yes'">
                            <v-card class="citrafleetYesFoam"
                                style="position: absolute; top: 30%; left: 5%; width: 90%; border: 1px solid #059BCA; border-radius: 9px;">
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px;">
                                    Tomar</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    3 comprimidos Aerored</p>
                                <p
                                    style="padding-top: 10%; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px;">
                                    Beber</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    1 Citrafleet diluido en 150 cc de agua</p>
                                <p
                                    style="padding-top: 3%; padding-bottom: 5%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    1 litro líquidos claros durante 30 minutos</p>
                            </v-card>
                        </div>
                        <div v-else>
                            <v-card class="citrafleetNoFoam"
                                style="position: absolute; top: 35%; left: 5%; width: 90%; border: 1px solid #059BCA; border-radius: 9px;">
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px;">
                                    Beber</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    1 Citrafleet diluido en 150 cc de agua</p>
                                <p
                                    style="padding-top: 3%; padding-bottom: 5%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    1 litro líquidos claros durante 30 minutos</p>
                            </v-card>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="this.currentFoam == 'Yes'">
                            <v-card class="noCitrafleetYesFoam"
                                style="position: absolute; top: 20%; left: 5%; width: 90%; border: 1px solid #059BCA; border-radius: 9px;">
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px;">
                                    Tomar</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    3 comprimidos Aerored</p>
                                <p
                                    style="padding-top: 5%; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px;">
                                    Beber</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    1 Movigrep A</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    1 Movigrep B</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    diluidos juntos en 1 litro de agua</p>
                                <p
                                    style="padding-top: 3%; padding-bottom: 5%; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px;">
                                    beber 1 vaso cada 15 minutos</p>
                            </v-card>
                        </div>
                        <div v-else>
                            <v-card class="noCitrafleetNoFoam"
                                style="position: absolute; top: 30%; left: 5%; width: 90%; border: 1px solid #059BCA; border-radius: 9px;">
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px;">
                                    Beber</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    1 Movigrep A</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    1 Movigrep B</p>
                                <p
                                    style="padding-top: 3%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px;">
                                    diluidos juntos en 1 litro de agua</p>
                                <p
                                    style="padding-top: 3%; padding-bottom: 5%; font-family: Lato; color: #3F616C; text-align: center; font-size: 16px;">
                                    beber 1 vaso cada 15 minutos</p>
                            </v-card>
                        </div>
                    </div>
                    <v-icon style="position: absolute; bottom: 9%; left: 47%" medium color="#3F616C">
                        error_outline</v-icon>
                    <p
                        style="position:absolute; bottom: 3%; left: calc(50% - 215px/2 + 0.5px); font-family: Lato; color: #000000; text-align: center; font-size: 12px;">
                        Puede tomar el agua adicional que desee</p>
                </v-card>
                    <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh)); width: calc(100svw - 2svw - 2svw); margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: center; flex-flow: row">
                    <v-btn elevation="12" v-on:click="click();"
                        style="margin-left: auto; margin-right: auto; width: 208px; height: 69px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                        <b>Continuar</b>
                    </v-btn>
                </v-card>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>

import CardNav from './CardNav.vue';
import { nextScreen } from '../router/utils.js';

export default {
    name: 'Instructions',
    components: {
        CardNav
    },
    data() {
        return {
            foam: null,
            medicine: null,
        }
    },
    computed: {
        currentFoam: {
            get: function () {
                return this.foam;
            },
            set: function (newValue) {
                this.foam = newValue;
            }
        },
        currentMedicine: {
            get: function () {
                return this.medicine;
            },
            set: function (newValue) {
                this.medicine = newValue;
            }
        },
    },
    methods: {
        matchHeight() {
            this.currentFoam = this.$route.params.fi;
            this.currentMedicine = this.$route.params.sec;
            this.configure();
        },
        configure() {
            var externalTop = "";
            if (this.currentMedicine == 'Citrafleet') {
                if (this.currentFoam == 'Yes') {
                    externalTop = document.getElementsByClassName("citrafleetYesFoam")[0];
                } else {
                    externalTop = document.getElementsByClassName("citrafleetNoFoam")[0];
                }
            } else {
                if (this.currentFoam == 'Yes') {
                    externalTop = document.getElementsByClassName("noCitrafleetYesFoam")[0];
                } else {
                    externalTop = document.getElementsByClassName("noCitrafleetNoFoam")[0];
                }
            }
        },
        click() {
            nextScreen(this.$router, '/endtreatmentnewphoto');
        }
    },
    mounted() {
        this.matchHeight();
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Instructions.vue